<template>
<section v-if="state.hasOccurrenceMap" id="occurrenceSection" class="section bgLight pretty-top" :class="{'pretty-top-white pretty-bottom-grey': (!toShowOverviewTab && hasAnyStatusTabSections),
  'pretty-top-white1 pretty-bottom': (!toShowOverviewTab && !hasAnyStatusTabSections && !hasNLSighting)}">
  <div class="sectionBg dim map"></div>
  <div class="container">
    <div class="columns is-multiline is-vcentered is-centered">
      <div class="column is-12-tablet has-text-centered">
        <h2 class="has-text-centered">{{ $t("profile.aboutSpp.mapHeader") }}</h2>
        <div class="bold" v-html="$t('profile.aboutSpp.mapDescription', {sppName: state.sppName, startYear: state.sppGroup?.occurrenceMapStartYear, endYear: state.sppGroup?.occurrenceMapEndYear})"></div>
        <div class="bold" v-if="state.hasWetland > 0 && state.sppGroup?.groupName?.includes('Plant')" v-html="$t('profile.aboutSpp.plantMapDescription', {sppName: state?.sppName, startYear: state.sppGroup?.occurrenceMapStartYear, endYear: state.sppGroup?.occurrenceMapEndYear})"></div>
      </div>
      <div class="column is-10-tablet">
        <AlbertaStandardMap :widthPct="60" :layerNames="layerNames" :extra-layers="extraLayers" :legendLayerName="legendLayerName" />
      </div>
    </div>
  </div>
</section>

</template>

<script setup>
import { useApp } from '@/composables/state/profileState';
import AlbertaStandardMap from '@/components/map/AlbertaStandardMap.vue';
import { occurrenceMapName } from '@/config/profile-config.js';

const { state, toShowOverviewTab, hasAnyStatusTabSections, hasNLSighting } = useApp();
// const toShowMapDescription = ref(false);
const layerNames = [occurrenceMapName];

const nr = import.meta.env.VITE_APP_NR_LAYER.split(',');
const extraLayers = [{ id: nr[0], name: nr[1] }]
const legendLayerName = [occurrenceMapName, nr[1]];

</script>
